import React, { useEffect, useRef, useState } from 'react';
import Box from '@mui/material/Box';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Grid, TextField, Button } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Web3 from 'web3'
import { useNavigate } from 'react-router-dom';

export default function Home() {

    const accessToken = useSelector(state => state.user.userAuth.accessToken);
    
    const userId =  useSelector(state => state.user.userAuth.username);

    const headers = {
        'Authorization': `Bearer ${accessToken}`,
        'Content-Type': 'application/json', // Adjust as needed
    };

    const navigate = useNavigate();
    const dispatch = useDispatch();

    const web3Ref = useRef();
    const pairTokensRef = useRef();
    const chainIdRef = useRef();
    const chainId = useSelector((state) => state.network.chainId);
    const [network, setNetwork] = React.useState(chainId);
    const [chainLoaded, setChainLoaded] = React.useState(true);
    const [tokenAddress, setTokenAddress] = React.useState('');
    const [dexes, setDexes] = React.useState([]);
    const [dexInfo, setDexInfo] = React.useState({ dexName: "", routerAddress: "", WETH: "" });
    const [tokenInfo, setTokenInfo] = React.useState({ tokenName: "", tokenSymbol: "" })
    const [wallets, setWallets] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [rows, setRows] = useState([]);
    const [feedback, setFeedback] = useState('');

    let web3

    useEffect(() => {

        if (chainId) {
            setDexes(exchanges[chainId].dex)
            web3Ref.current = new Web3(new Web3.providers.HttpProvider(exchanges[chainId].rpc));
            web3Ref.current = new Web3(exchanges[chainId].rpc);
            pairTokensRef.current = exchanges[chainId].pairTokens;
        }

    }, [chainId])

    useEffect(() => {
        if (web3) {
            setChainLoaded(true);
        }
    }, [web3])

    const exchanges = {
        1: {
            "dex": [
                {
                    "name": "UNISWAP",
                    "router": "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
                    "factory": "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f"
                },
                {
                    "name": "SUSHI",
                    "router": "0xd9e1cE17f2641f24aE83637ab66a2cca9C378B9F",
                    "factory": "0xC0AEe478e3658e2610c5F7A4A2E1777cE9e4f2Ac"
                }
            ],
            rpc: "https://rpc.ankr.com/eth/a73fe89349cfbee583048758151ac46d80a869ef5ddfaf4543cd4e49a707a0cb",
            pairTokens: [
                {
                    "name": "WETH",
                    "tokenAddress": "0xC02aaA39b223FE8D0A0e5C4F27eAD9083C756Cc2",
                }
            ]
        },
        56: {
            "dex": [
                {
                    "name": "PANCAKESWAP",
                    "router": "0x10ED43C718714eb63d5aA57B78B54704E256024E",
                    "factory": "0xcA143Ce32Fe78f1f7019d7d551a6402fC5350c73"
                },
            ],
            rpc: "https://rpc.ankr.com/bsc/a73fe89349cfbee583048758151ac46d80a869ef5ddfaf4543cd4e49a707a0cb",
            pairTokens: [
                {
                    "name": "WETH",
                    "tokenAddress": "0xbb4CdB9CBd36B01bD1cBaEBF2De08d9173bc095c",
                }
            ]
        },
        8453: {
            "dex": [
                {
                    "name": "BASESWAP",
                    "router": "0x00b86DD7Cb9A0f79e7Eba4a43a10343fB1C68F4f",
                    "factory": "0xFDa619b6d20975be80A10332cD39b9a4b0FAa8BB"
                }
            ],
            rpc: "https://rpc.ankr.com/base/a73fe89349cfbee583048758151ac46d80a869ef5ddfaf4543cd4e49a707a0cb",
            pairTokens: [
                {
                    "name": "WETH",
                    "tokenAddress": "0x4200000000000000000000000000000000000006",
                }
            ]
        },
        5: {
            "dex": [
                {
                    "name": "UNISWAP",
                    "router": "0x7a250d5630B4cF539739dF2C5dAcb4c659F2488D",
                    "factory": "0x5C69bEe701ef814a2B6a3EDD4B1652CB9cc5aA6f"
                },
                {
                    "name": "SUSHI",
                    "router": "0x1b02dA8Cb0d097eB8D57A175b88c7D8b47997506",
                    "factory": "0xc35DADB65012eC5796536bD9864eD8773aBc74C4"
                }
            ],
            rpc: "https://rpc.ankr.com/eth_goerli/a73fe89349cfbee583048758151ac46d80a869ef5ddfaf4543cd4e49a707a0cb",
            pairTokens: [
                {
                    "name": "WETH",
                    "tokenAddress": "0xB4FBF271143F4FBf7B91A5ded31805e42b2208d6",
                }
            ]
        }
    };

    // Define the Uniswap Factory contract ABI
    const factoryABI = [{ "inputs": [{ "internalType": "address", "name": "_feeToSetter", "type": "address" }], "payable": false, "stateMutability": "nonpayable", "type": "constructor" }, { "anonymous": false, "inputs": [{ "indexed": true, "internalType": "address", "name": "token0", "type": "address" }, { "indexed": true, "internalType": "address", "name": "token1", "type": "address" }, { "indexed": false, "internalType": "address", "name": "pair", "type": "address" }, { "indexed": false, "internalType": "uint256", "name": "", "type": "uint256" }], "name": "PairCreated", "type": "event" }, { "constant": true, "inputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "name": "allPairs", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "allPairsLength", "outputs": [{ "internalType": "uint256", "name": "", "type": "uint256" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "tokenA", "type": "address" }, { "internalType": "address", "name": "tokenB", "type": "address" }], "name": "createPair", "outputs": [{ "internalType": "address", "name": "pair", "type": "address" }], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": true, "inputs": [], "name": "feeTo", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [], "name": "feeToSetter", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": true, "inputs": [{ "internalType": "address", "name": "", "type": "address" }, { "internalType": "address", "name": "", "type": "address" }], "name": "getPair", "outputs": [{ "internalType": "address", "name": "", "type": "address" }], "payable": false, "stateMutability": "view", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "_feeTo", "type": "address" }], "name": "setFeeTo", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }, { "constant": false, "inputs": [{ "internalType": "address", "name": "_feeToSetter", "type": "address" }], "name": "setFeeToSetter", "outputs": [], "payable": false, "stateMutability": "nonpayable", "type": "function" }];

    // Function to detect the LP pool address
    async function detectLpPool(uniswapFactoryAddress, tokenAddress) {

        const web3 = web3Ref.current;
        const pairTokens = pairTokensRef.current;

        let factoryContract = new web3.eth.Contract(factoryABI, uniswapFactoryAddress);
        for (var a = 0; a < pairTokens.length; a++) {
            try {
                const token0Address = pairTokens[a].tokenAddress;
                const lpPool = await factoryContract.methods.getPair(token0Address, tokenAddress).call({ gas: 3000000 });
                console.log(lpPool)
                if (lpPool !== '0x0000000000000000000000000000000000000000') {
                    return { feedback: "found", lpAddress: lpPool }
                } else {
                    return { feedback: "notFound", lpAddress: "" }
                }

            } catch (error) {
                //console.error('Error detecting LP pool:', error);
            }
        }
        return { feedback: "notFound", lpAddress: "" };
    }

    async function getAddressBalance() {
        const web3 = web3Ref.current;

        const address = '0xd86aC952724Cb84143B45c7dBf3e3144B65541CC';

        const weiBalance = await web3.eth.getBalance(address);

        // Convert the balance from wei to Ether
        const etherBalance = web3.utils.fromWei(weiBalance, 'ether');

        console.log(etherBalance)
    }

    const searchLpPool = async (tokenAddress) => {

        setDexInfo({ dexName: "", routerAddress: "", WETH: "" });
        setTokenInfo({ tokenName: "", tokenSymbol: "" })

        setTokenAddress(tokenAddress)

        getTokenInfo(tokenAddress);

        for (var a = 0; a < dexes.length; a++) {
            const factory = dexes[a].factory;
            const searchLp = await detectLpPool(factory, tokenAddress)
            if (searchLp.feedback == "found") {
                console.log(searchLp)
                setDexInfo({ dexName: dexes[a].name, chainId, routerAddress: dexes[a].router, WETH: exchanges[chainId].pairTokens[0].tokenAddress });
                return;
            }
        }

    }

    const getTokenInfo = async (tokenAddress) => {

        const web3 = web3Ref.current;

        const tokenABI = [
            {
                constant: true,
                inputs: [],
                name: 'name',
                outputs: [
                    {
                        name: '',
                        type: 'string',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
            {
                constant: true,
                inputs: [],
                name: 'symbol',
                outputs: [
                    {
                        name: '',
                        type: 'string',
                    },
                ],
                payable: false,
                stateMutability: 'view',
                type: 'function',
            },
        ];

        try {
            const tokenContract = new web3.eth.Contract(tokenABI, tokenAddress);
            // Retrieve the name and symbol of the ERC-20 token
            const name = await tokenContract.methods.name().call();
            const symbol = await tokenContract.methods.symbol().call();
            setTokenInfo({ tokenName: name, tokenSymbol: symbol });
        } catch (error) {
            console.error('Error retrieving token info:', error);
        }

    };

    const handleChange = (event) => {
        setNetwork(event.target.value);
        dispatch({ type: 'UPDATECHAINID', chainId: event.target.value })
    };

    const loadWallets = async () => {

        setIsLoading(true);

        try {

            const request = await fetch(`${process.env.REACT_APP_API_URL}/getWallets`, {
                method: 'GET',
                headers,
            });
            const response = await request.json();

            setFeedback(JSON.stringify(response));

            if (response.feedback == "success") {

                if (response.data.wallets.length > 0) {

                    setWallets(response.data.wallets);

                    //setDexes(response.data.dexInfo)

                    setRows(response.data.wallets.map((row) => ({ ...row, amount: '' })));
                    //console.log(rows)
                    await fetchBalances(response.data.wallets);

                } else {

                    setWallets(['']);

                }

            } else {

                setWallets([''])

            }

            setIsLoading(false);

        } catch (e) {
            console.log(e)
            setIsLoading(false);

            toast.error('An error occurred', {
                position: "top-center"
            })

        }

    }

    const fetchBalances = async (wallets) => {

        const promises = wallets.map(async (row) => {
            try {
                const balance = await getMultiBalance(`${row.wallet_address}`, [1]);
                return { ...row, balance }; // Combine the balance with the row data
            } catch (error) {
                console.error('Error fetching balance:', error);
                return row; // If an error occurs, keep the original row data
            }

        });

        const updatedWallets = await Promise.all(promises);
        setWallets(updatedWallets); // Update the component's state with the fetched balances
    };

    const getMultiBalance = async (address, chains) => {

        let totalBalance = 0;

        //for (let a = 0; a < chains.length; a++) {
        totalBalance = await getBalance(address, chainId);
        //}

        return `${totalBalance}`;

    }

    const getBalance = async (walletAddress, chainId) => {

        const web3 = web3Ref.current;

        // Replace with the Ethereum address you want to check
        const addressToCheck = `${walletAddress}`;

        try {

            const weiBalance = await web3.eth.getBalance(addressToCheck);

            // Convert the balance from wei to Ether
            const etherBalance = web3.utils.fromWei(weiBalance, 'ether');

            return etherBalance;

        } catch (e) {
            return 0;
        }

    }

    const [message, setMessage] = useState('');

    useEffect(() => {

        loadWallets();
        
    }, []);

    const handleInputChange = (event, index, field) => {
        const updatedRows = [...rows];
        updatedRows[index][field] = event.target.value;

        // Update the value of extraColumn based on the input field's value
        if (field === 'extraColumn') {
            updatedRows[index].extraColumn = event.target.value;
        }

        setRows(updatedRows);
    };

    const generateTradeId = () => {
        const min = 1000000000; // Minimum 10-digit number
        const max = 9999999999; // Maximum 10-digit number
        const random10DigitNumber = Math.floor(Math.random() * (max - min + 1)) + min;
        return random10DigitNumber;
    };

    const createBulkTrade = async () => {

        if (tokenInfo.tokenName == "") {
            toast.error("Invalid Token", {
                position: "top-center"
            })
            return;
        }

        const dataToInsert = rows.filter(
            (row) => row.wallet_address.trim() !== '' && row.amount.trim() != ''
        );

        for (let i = 0; i < dataToInsert.length; i++) {
            const item = dataToInsert[i];
            item.tradeId = generateTradeId();
        }

        if (dataToInsert.length == 0) {
            toast.error("No wallet selected", {
                position: "top-center"
            })
            return;
        }

        try {
            console.log(dataToInsert)
            const request = await fetch(`${process.env.REACT_APP_API_URL}/createBulkTrade`, {
                method: 'POST',
                headers,
                body: JSON.stringify({ data: dataToInsert, dexInfo, tokenAddress }),
            });

            const response = await request.json();
            console.log(response)
            if (response.feedback == "success") {

                navigate("/trades");
                return;

            }

        } catch (error) {
            console.error('Fetch error:', error);
        }
    };

    const handlePasteClick = async () => {
        try {
            const clipboardText = await navigator.clipboard.readText();
            searchLpPool(clipboardText);
        } catch (error) {
            console.error('Error pasting from clipboard:', error);
        }
    };

    useEffect(() => {
        loadWallets();
    }, [network])

    return (
        <div style={{ padding: 20, paddingTop: 5 }}>

            <Box sx={{ maxWidth: 200, marginLeft: 'auto', marginRight: 'auto', marginBottom: 3 }}>
                <FormControl fullWidth>
                    <InputLabel id="demo-simple-select-label">Network</InputLabel>
                    <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={network}
                        label="Network"
                        onChange={handleChange}
                    >
                        <MenuItem value={1}>Ethereum</MenuItem>
                        <MenuItem value={56}>BSC</MenuItem>
                        <MenuItem value={8453}>BASE</MenuItem>
                        <MenuItem value={5}>Goerli</MenuItem>
                    </Select>
                </FormControl>
            </Box>

            {chainLoaded &&
                <>
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            {/* Column 1 content */}
                            <div>
                                <TextField
                                    label="Token Address"
                                    id="outlined-size-small"
                                    size="small"
                                    value={tokenAddress}
                                    onChange={(event) => searchLpPool(event.target.value)}
                                />

                                <Button variant="contained" size="medium" onClick={handlePasteClick}>
                                    Paste
                                </Button>
                            </div>
                        </Grid>
                    </Grid>
                    {tokenInfo.tokenName != "" &&
                        <>
                            <br />
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {/* Column 1 content */}
                                    <div><b>Name:</b> {tokenInfo.tokenName}  <b>Symbol:</b> {tokenInfo.tokenSymbol}</div>
                                </Grid>
                            </Grid>
                        </>
                    }
                    {dexInfo.dexName != "" &&
                        <>
                            <br />
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    {/* Column 1 content */}
                                    <div><b>Exchange:</b> {dexInfo.dexName}</div>
                                </Grid>
                            </Grid>
                        </>
                    }
                    <br />
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Button variant="contained" onClick={() => createBulkTrade()}>SEND </Button>
                        </Grid>
                    </Grid>
                    <br />
                </>
            }

            <div style={{ marginBottom: 100, boxShadow: '0px 0px 5px rgba(0, 0, 0, 0.5)', padding: 10 }}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        {/* Column 1 content */}
                        <div>
                            Wallet Address
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                        {/* Column 1 content */}
                        <div>
                            Balance
                        </div>
                    </Grid>
                    <Grid item xs={4}>
                        {/* Column 1 content */}
                        <div>
                            Amount
                        </div>
                    </Grid>
                </Grid>
                <br />
                {wallets.map((wallet, index) => {
                    return (
                        <Grid container spacing={2} key={index}>
                            <Grid item xs={4}>
                                {/* Column 1 content */}
                                <div style={{ maxWidth: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                    <span style={{ fontSize: 12 }}>{wallet.wallet_address}</span>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                {/* Column 1 content */}
                                <div style={{ maxWidth: '100%', overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                                    <span>{wallet.balance}</span>
                                </div>
                            </Grid>
                            <Grid item xs={4}>
                                {/* Column 1 content */}
                                <div style={{ marginBottom: 5 }}>
                                    <TextField
                                        label=""
                                        id="outlined-size-small"
                                        size="small"
                                        value={wallet.amount}
                                        onChange={(event) => handleInputChange(event, index, 'amount')}
                                    />
                                </div>
                            </Grid>
                        </Grid>
                    )

                })}

            </div>

            <ToastContainer />

        </div>
    )
}